import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RefundStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-refund-status',
  templateUrl: './refund-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe]
})
export class RefundStatusComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;
  constructor() { }

  ngOnInit(): void {
  }


}
